import { ProtectYou } from 'shared/components/ProtectYou';
import { AccordionContainer } from '../AccordionContainer';
import { PROTECT_YOU } from 'shared/constants/protectYou';

export const ProtectYouContainer: React.FC = () => {
  return <ProtectYou accordion={<AccordionContainer items={PROTECT_YOU} />} />;
};
